export default function (numerals) {
    return function (value) {
        return value.replace(/[0-9]/g, function (i) {
            return numerals[+i];
        });
    };
}
